export enum EPaymentsProvider {
  Stripe = "stripe",
}
